import { GoalMetric, PerformanceMetric, TimeRange } from '../../../../providers/api/dtos';
import { template } from '../../../../utils/text/text';

const performanceTemplatedTitle: Record<GoalMetric, string> = {
  rumors: 'Il team ha inserito {PERFORMANCE} notizie su un obiettivo di {GOAL}',
  prospects: 'Il team ha effettuato {PERFORMANCE} valutazioni su un obiettivo di {GOAL}',
  assignments: 'Il team ha acquisito {PERFORMANCE} mandati su un obiettivo di {GOAL}',
  sales: 'Il team ha concluso {PERFORMANCE} vendite su un obiettivo di {GOAL}',
};

export const getPerformanceTitle = ({
  metric,
  metricData,
}: {
  metric: GoalMetric,
  metricData: Record<TimeRange, PerformanceMetric>,
}): string => template(performanceTemplatedTitle[metric], {
  PERFORMANCE: metricData.yearly.performance,
  GOAL: Math.round(metricData.yearly.goal),
});
